import { TransitiveCompileNgModuleMetadata } from '@angular/compiler';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AvtDialogDeleteComponent } from 'src/app/avt-dialog-delete/avt-dialog-delete.component';
import { ListeComponent } from 'src/app/liste/liste.component';
import { DateService } from 'src/app/services/date.service';
import { GeneralService } from 'src/app/services/general.service';

@Component({
  selector: 'app-liste-reservation',
  templateUrl: './liste-reservation.component.html',
  styleUrls: ['./liste-reservation.component.scss'],
})
export class ListeReservationComponent implements OnInit {
  constructor(
    private generalService: GeneralService,
    private dateService: DateService,
    public router: Router
  ) {}
  @ViewChild('frmAlertDup', { static: false }) frmAlertDup;
  @ViewChild('listeConmponent', { static: false })
  listeConmponent: ListeComponent;
  @ViewChild('listeDetailConmponent', { static: false })
  listeDetailConmponent: ListeComponent;
  exist: boolean = true;
  listeReservation = [];
  currentUrl = this.router.url;
  columnsReservation;
  columnsReservationDetail;
  date_Debut: Date;
  date_Fin: Date;
  buttonName: string = '';
  pageTitle: string = '';
  buttonLink: string = '';
  listeReservationDetail = [];
  listBtn = [
    // {name:"consulter",class:"colorGreen",text:"Consulter",disabled : false,icon:"search"},
    {
      name: 'ajouter',
      class: 'colorGreen',
      text: 'Ajouter',
      disabled: false,
      icon: 'add',
    },
    {
      name: 'modifier',
      class: 'colorBlue',
      text: 'Modifier',
      disabled: false,
      icon: 'edit',
    },
    {
      name: 'supprimer',
      class: 'colorRed',
      text: 'Supprimer',
      disabled: false,
      icon: 'delete',
    },
    {
      name: 'dupliquer',
      class: 'colorGreen',
      text: 'Dupliquer',
      disabled: false,
      icon: 'content_copy',
    },
  ];
  ngOnInit(): void {
    this.date_Fin = new Date();
    this.date_Debut = new Date('01-01-2020');
    //this.date_Debut.setDate(this.date_Debut.getDate() - 7);
    this.getColonneReservation();

    if (this.router.url == '/avt/grh/liste/modeles') {
      setTimeout(() => {
        this.getListeStandars();
      }, 500);
      this.pageTitle = 'Liste des Modèles';
      this.buttonLink = '/avt/grh/liste/reservation';
    } else {
      setTimeout(() => {
        this.getListeReservation();
      }, 500);
      this.pageTitle = 'Liste des Circuits';
      this.buttonLink = '/avt/grh/liste/modeles';
    }

    // this.getcolumnsReservationDetail();
  }
  getColonneReservation() {
    this.generalService
      .rechercheTable('recherche/TbRecherche?param=Travel')
      .subscribe((data) => {
        if (data && data.TableRD.length > 0) this.columnsReservation = data;
        //console.log(this.columnsReservation.TableRD);

        this.columnsReservation.TableRD.push(
          {
            Lg_Code: 'Travel_Ref',
            Lg_Langue: null,
            TableRD_Alligement: 0,
            TableRD_Champs: 'Travel_Ref',
            TableRD_Des: 'Ref ',
            TableRD_ExpressionH: null,
            TableRD_ExpressionR: null,
            TableRD_Format: null,
            TableRD_Largeur: 100,
            TableRD_Ordre: 0,
            TableRD_Param1: null,
            TableRD_Param2: null,
            TableRD_Param3: null,
            TableRD_ReadOnly: false,
            TableRD_Tri: true,
            TableRD_Type: 0,
            TableRD_ValDef: null,
            TableRD_Valid: null,
            TableRD_ValidType: 0,
            TableRE_Code: 'Travel',
            User_Groupe: null,
            User_Id: '*',
            iconSort: 'sort',
          },
          {
            Lg_Code: 'Travel_version',
            Lg_Langue: null,
            TableRD_Alligement: 0,
            TableRD_Champs: 'Travel_version',
            TableRD_Des: 'version ',
            TableRD_ExpressionH: null,
            TableRD_ExpressionR: null,
            TableRD_Format: null,
            TableRD_Largeur: 100,
            TableRD_Ordre: 0,
            TableRD_Param1: null,
            TableRD_Param2: null,
            TableRD_Param3: null,
            TableRD_ReadOnly: false,
            TableRD_Tri: true,
            TableRD_Type: 0,
            TableRD_ValDef: null,
            TableRD_Valid: null,
            TableRD_ValidType: 0,
            TableRE_Code: 'Travel',
            User_Groupe: null,
            User_Id: '*',
            iconSort: 'sort',
          }
        );
        this.columnsReservation.TableRD.splice(5, 1);
      });
  }
  getcolumnsReservationDetail() {
    this.generalService
      .rechercheTable('recherche/TbRecherche?param=travelD')
      .subscribe((data) => {
        if (data && data.TableRD.length > 0)
          this.columnsReservationDetail = data;
      });
  }
  getListeReservation() {
    if (this.date_Debut && this.date_Fin) {
      this.generalService
        .rechercheTable(
          this.generalService.url +
            'Travel&param=' +
            this.dateService.setFormatDateRechercheServer(this.date_Debut) +
            ',' +
            this.dateService.setFormatDateRechercheServer(this.date_Fin)
        )
        .subscribe(
          (data) => {
            console.log(data);

            this.listeReservation = data;
            //console.log(this.listeReservation);

            this.exist = true;
          },
          () => {
            this.exist = true;
            this.generalService.dialogSuccess(
              'pas de donnée disponible',
              false
            );
          }
        );
    }
    this.buttonName = 'List Modèles';
  }

  getListeStandars() {
    this.generalService.rechercheTable2('Api_travelS').subscribe(
      (data: any) => {
        console.log(data);

        this.listeReservation = data;
      },
      () => {
        this.generalService.dialogSuccess('pas de donnée disponible', false);
      }
    );
    this.buttonName = 'List Circuits';
  }
  Toevent;
  openDialogueAlertDup(event) {
    this.Toevent = event;
    this.generalService.dialog.open(this.frmAlertDup, {
      width: '35vw',
      height: '30vh',
      disableClose: true,
    });
  }

  output(event) {
    if (event.action == 'clickRow') {
      //this.getDeailReservation(event.row.Travel_Code)
    }
    if (event.action == 'clickBtnHeat') {
      if (event.bouton.name === 'ajouter') {
        if (this.router.url == '/avt/grh/liste/modeles') {
          this.router.navigate(['avt/grh/reservation', '-1', '1'], {
            queryParams: { mode: 'model' }, // or 'circuit'
          });
        } else {
          this.router.navigate(['avt/grh/reservation', '-1', '1'], {
            queryParams: { mode: 'circuit' },
          });
        }
        return;
      }
      if (event.liste.row) {
        // if(event.bouton.name == "consulter")
        //   this.router.navigate(["grh/reservation",event.liste.row.Travel_Code, "3"])
        if (event.bouton.name == 'modifier')
          this.router.navigate([
            'avt/grh/reservation',
            event.liste.row.Travel_Code,
            '2',
          ]);
        if (event.bouton.name == 'supprimer') {
          this.supprimer(event);
        }
        if (event.bouton.name == 'dupliquer') {
          this.openDialogueAlertDup(event.liste.row.Travel_Code);
        }
      } else
        this.generalService.dialogSuccess(
          'Veillez sélectionner une ligne',
          false
        );
    }
    if (event.action == 'dbClick') {
      this.router.navigate([
        'avt/grh/reservation',
        event.liste.row.Travel_Code,
        '2',
      ]);
    }
  }
  supprimer(event) {
    const dialogConfig = this.generalService.dialogConfig;
    dialogConfig.autoFocus = true;
    var dialogRef = this.generalService.dialog.open(
      AvtDialogDeleteComponent,
      dialogConfig
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result == 'supprimer') {
        this.exist = false;
        this.listBtn.forEach((btn) => {
          btn.disabled = true;
        });
        this.generalService
          .delete(event.liste.row.Travel_Code, 'Travel')
          .subscribe(() => {
            this.generalService.dialogSuccess('Supprimer', true);
            if (this.router.url == '/avt/grh/liste/modeles') {
              this.getListeStandars();
            } else {
              this.getListeReservation();
            }
            this.exist = true;
            this.listBtn.forEach((btn) => {
              btn.disabled = false;
            });
          });
      }
    });
  }

  close() {
    this.generalService.dialog.closeAll();
  }

  getDeailReservation(Travel_Code) {
    this.exist = false;
    this.generalService
      .rechercheTable('ds/formdata?code=travel&val=' + Travel_Code)
      .subscribe((data) => {
        this.listeReservationDetail = data.TravelD;
        this.listeReservationDetail.forEach((reservationD) => {
          var TravelD_TypeEvent = this.generalService.listeTypeEvennement.find(
            (TravelD_TypeEvent) => {
              return (
                TravelD_TypeEvent.TravelD_TypeEvent ==
                reservationD.TravelD_TypeEvent
              );
            }
          );
          reservationD.TravelD_TypeEvent = TravelD_TypeEvent
            ? TravelD_TypeEvent.text
            : reservationD.TravelD_TypeEvent;
          var TravelD_Type = this.generalService.listeType.find(
            (TravelD_TypeEvent) => {
              return TravelD_TypeEvent.value == reservationD.TravelD_Type;
            }
          );
          reservationD.TravelD_Type = TravelD_Type
            ? TravelD_Type.text
            : reservationD.TravelD_Type;
        });
        this.exist = true;
      });
  }

  circuit;
  reservation;
  reservationDay = [];
  reservationDayM = [];
  //dupliquer circuit
  DupliquerCircuit(oldTravelcode) {
    //console.log(oldTravelcode);
    let oldcircuit;
    let oldreservation;
    let oldreservationDay;
    let oldreservationDayM;
    let lastversion;
    var url = 'ds/formdata?code=Travel';
    url += '&val=' + oldTravelcode;
    this.generalService.rechercheTable(url).subscribe((data) => {
      oldcircuit = data;
      oldreservation = oldcircuit.Travel[0];
      this.generalService
        .rechercheTable('API_Version', oldreservation.Travel_GroupID)
        .subscribe(
          (LastVersion) => {
            //console.log(LastVersion);
            lastversion = LastVersion[0].Expr1;

            //console.log(oldcircuit);

            oldreservationDay = oldcircuit.TravelD;
            oldreservationDayM = oldcircuit.TravelDM;

            //init Travel
            var url = 'ds/formdata?code=Travel';
            var travelcode;
            this.generalService.rechercheTable(url).subscribe((data) => {
              this.circuit = data;
              if (url) {
                this.circuit.Travel[0].Travel_Code = new Date()
                  .getTime()
                  .toString();
              }
              //modifier
              this.reservation = this.circuit.Travel[0];

              this.circuit.ApiForm[0].For_Val =
                this.circuit.Travel[0].Travel_Code;

              if (url) {
                this.reservation.Tiers_code = oldreservation.Tiers_code;
                this.reservation.Travel_DateDeb = oldreservation.Travel_DateDeb;
                this.reservation.Travel_DateDup = new Date().toISOString();
                this.reservation.Travel_origineDup = oldTravelcode;
                this.reservation.Travel_DateFin = oldreservation.Travel_DateFin;
                this.reservation.Travel_GroupID = oldreservation.Travel_GroupID;
                this.reservation.Travel_NbJour = oldreservation.Travel_NbJour;
                this.reservation.Travel_NbPerso = oldreservation.Travel_NbPerso;
                this.reservation.Travel_NbAccompagnant =
                  oldreservation.Travel_NbAccompagnant;
                this.reservation.Travel_NbGuide = oldreservation.Travel_NbGuide;
                this.reservation.Travel_NbChauffeur =
                  oldreservation.Travel_NbChauffeur;
                this.reservation.Travel_Nom =
                  oldreservation.Travel_Nom + ' (Copie)';
                this.reservation.Travel_Ref = oldreservation.Travel_Ref;
                this.reservation.Travel_Saison = oldreservation.Travel_Saison;
                this.reservation.Travel_Type = oldreservation.Travel_Type;
                this.reservation.U_timestamp = null;
                this.reservation.Travel_version = lastversion;
                this.reservation.Travel_statut = oldreservation.Travel_statut;
                this.reservation.Travel_Nature = oldreservation.Travel_Nature;
                this.reservation.Travel_statut1 = oldreservation.Travel_statut1;
                this.reservation.Travel_TVA = oldreservation.Travel_TVA;
                this.reservation.Marge = oldreservation.Marge;
                oldreservationDay.forEach((ord) => {
                  ord.Travel_Code = this.circuit.Travel[0].Travel_Code;
                  ord.U_timestamp = null;
                  this.reservationDay.push(ord);
                });
                this.circuit.TravelD = this.reservationDay;

                oldreservationDayM.forEach((ord) => {
                  ord.Travel_Code = this.circuit.Travel[0].Travel_Code;
                  ord.U_timestamp = null;
                  this.reservationDayM.push(ord);
                });
                this.circuit.TravelDM = this.reservationDayM;
              }
              console.log(this.circuit);

              this.generalService.enregisterTable(this.circuit).subscribe(
                (data) => {
                  this.generalService.dialogSuccess('Dupliqué', true);
                  if (this.router.url == '/avt/grh/liste/modeles') {
                    setTimeout(() => {
                      this.getListeStandars();
                    }, 500);
                  } else {
                    setTimeout(() => {
                      this.getListeReservation();
                    }, 500);
                  }
                  this.generalService.dialog.closeAll();
                  this.generalService.dialog.closeAll();
                },
                () => {
                  this.generalService.dialogSuccess('Non Dupliqué', false);
                }
              );
            });
          },
          () => {
            this.generalService.dialogSuccess('Non Dupliqué', false);
          }
        );
    });
  }

  //get last version circuit
  getVersionCircuit(travelRef) {
    this.generalService
      .rechercheTable('API_Version', travelRef)
      .subscribe((res) => {
        //console.log(res);
        return res[0].Expr1;
      });
  }

  openInNewTab(link: string): void {
    const url = this.router.serializeUrl(this.router.createUrlTree([link]));
    window.open(url, '_blank');
  }
}
